export default __webpack_public_path__ + "static/media/logo.bc3409ff.png";